import { Button, Icon } from 'gu-ui-kit'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import PropTypes from 'prop-types'
import styles from 'modules/Referral/ReferralLinks/referral.module.scss'
import { notificationShow } from 'modules/Notifications/actions'
export const LinkCell = ({ url }) => {
  const dispatch = useDispatch()
  const writeToClipboard = useWriteToClipboard()
  const onClickHandle = useCallback(
    (text) => {
      writeToClipboard(text)

      dispatch(
        notificationShow({
          type: 'success',
          message:
            'referral::referral_links.notifications.success_copy_notification',
        }),
      )
    },
    [writeToClipboard],
  )

  return (
    <Button
      className={styles['referral-links__url']}
      onClick={() => onClickHandle(url)}
      type={'button'}
      variant={'ghost'}
      endIcon={<Icon name={'copy'} />}
      link
      noWrap
    >
      {url}
    </Button>
  )
}

LinkCell.propTypes = {
  url: PropTypes.string,
}
